import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.userSearchResult,
      "loading": _vm.isLoading,
      "search-input": _vm.search,
      "color": _vm.color,
      "label": _vm.label ? _vm.label : _vm.$i18n_t('Common.userWithSearch'),
      "placeholder": _vm.label ? '' : _vm.$i18n_t('Common.searchUser'),
      "prepend-icon": _vm.hideIcon ? '' : 'mdi-account',
      "rules": _vm.rules,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "title",
      "item-value": "id",
      "return-object": "",
      "required": "",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "name": "userObjectParent"
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": function ($event) {
        return _vm.process();
      }
    },
    model: {
      value: _vm.lclObject,
      callback: function ($$v) {
        _vm.lclObject = $$v;
      },
      expression: "lclObject"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };